<template>
  <v-container fluid class="white data-inline-content">
    <div class="qmkey-related-inline-table">
      <v-data-table
        :headers="evidencesColumns"
        :items="current_qunit[props.attr]"
        item-key="uid"
        class="qmkey-explorer-table-expansion-table"
        dense
        sort-by="version"
        must-sort
        sort-desc
      >
        <template v-slot:[`item.mimetype`]="{ item }">
          <v-icon small class="mr-2" :color="files[item.mimetype].color">
            {{ files[item.mimetype].icon }}
          </v-icon>
        </template>
        <!-- Actions -->
        <template v-slot:[`item.actions`]="{ item }">
          <v-btn 
            small
            icon
            :disabled="!item.value"
            @click="handleEvidence(item)"
            >
            <v-icon small class="mr-2"> mdi-download </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </div>
  </v-container>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import QUnit from '@/api/QUnit'

export default {
  name: 'InlineBoxVersions',
  props: {
    current_qunit: Object,
    props: Object
  },
  data() {
    return {
      options: {
        sortBy: 'version',
      },
      selected: [],
      evidencesColumns: [
        { value: 'mimetype', text: 'Tipo', sortable: false },
        { value: 'title', text: 'Titulo', sortable: false },
        { value: 'creation_date', text: 'F. Creación', sortable: false },
        {
          value: 'modification_date',
          text: 'F. Modificación',
          sortable: false,
        },
        {
          value: 'version',
          text: 'Version',
          sortable: false,
        },
        { value: 'actions', text: 'Actions', sortable: false },
      ],
      files: {
        pdf: {
          icon: 'mdi-file-pdf-box',
          color: '#b30b00',
        },
        xls: {
          icon: 'mdi-file-excel',
          color: '#207345',
        },
        msword: {
          icon: 'mdi-file-word',
          color: '#2b569a',
        },
        pptx: {
          icon: 'mdi-file-powerpoint',
          color: '#d24625',
        },
        image: {
          icon: 'mdi-file-image',
          color: '#753c8f',
        },
        video: {
          icon: 'mdi-file-video',
          color: '#f7a42f',
        },
        file: {
          icon: 'mdi-file',
          color: '#0e85cd',
        },
      },
    }
  },
  watch: {
    fields_to_collect() {
      // This is to inject javascript when form is loaded
      this.$nextTick(() => {
        if (this.jsdata) {
          var jsscript = document.createElement('script')
          jsscript.innerText = this.jsdata
          document.head.appendChild(jsscript)
        }
      })
    },
  },
  computed: {
    ...mapState([
      'sitePath',
    ]),
  },  
  methods: {
    handleEvidence(row){
      this.$emit('download_file', row)
      // QUnit.getQUnitFile(
      //   this.sitePath,
      //   row.qunit_id,
      //   row.attribute,
      //   row.value
      // ).then(data =>{
      //   this.downloadFile(data, row.title)
      // }).catch(error =>
      //   console.log('handleEvidence', error)
      // )
    },    
    downloadFile(data, filename) {
      // It is necessary to create a new blob object with mime-type explicitly set
      // otherwise only Chrome works like it should
      var newBlob = new Blob([data.data], {type: 'application/vnd'})

      // IE doesn't allow using a blob object directly as link href
      // instead it is necessary to use msSaveOrOpenBlob
      if (window.navigator && window.navigator.msSaveOrOpenBlob) {
          window.navigator.msSaveOrOpenBlob(newBlob)
          return
      }

      // For other browsers:
      // Create a link pointing to the ObjectURL containing the blob.
      const ob = window.URL.createObjectURL(newBlob)
      var link = document.createElement('a')
      link.href = ob
      link.download = filename //+ '.docx'
      link.click()
      setTimeout(function () {
          // For Firefox it is necessary to delay revoking the ObjectURL
          window.URL.revokeObjectURL(ob)
      }, 100)
    }
  }
}
</script>


<style lang="scss">
@import '@/sass/explorer.scss';
</style>
